// removed by extract-text-webpack-plugin
module.exports = {"header":"header__31A_7","logo":"logo__2kwkS","logo_center":"logo_center__1tQ3D","header_link":"header_link__1VdHl","about_i":"about_i__3Fz0n"};


//////////////////
// WEBPACK FOOTER
// ./components/header/style.scss
// module id = /Umn
// module chunks = 3